import React from 'react';
import BannerSlider from './BannerSlider';
import About from './About';
import Services from './Services';
import IndustrialAutomationSection from './IndustrialAutomationSection';
import Works from './Works';
import ContactHome from './ContactHome';
import Clients from './Clients';
import Footer from './Footer';

const Home = () => {
  return (
    <>
      <BannerSlider />
      <Clients />
      <About />
      <Services />
      <IndustrialAutomationSection />
      <Works />
      <ContactHome />
      <Footer />
    </>
  );
};

export default Home;

